import React, { useEffect, useState } from 'react';
import { formatVerseTuple } from '../../utils/verse_reference_parser';

const PAGE_SIZE = 50;

export function DeckInfoTab({ deck }) {
  const [page, setPage] = useState(0);
  const allVerses = Array.isArray(deck.verses) ? deck.verses : [];
  const pageCount = Math.max(1, Math.ceil(allVerses.length / PAGE_SIZE));
  const verses = allVerses.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
  const deckName = typeof deck.deck_name === 'string' && deck.deck_name.trim()
    ? deck.deck_name
    : 'Untitled Deck';
  const verseCount = Number.isInteger(deck.verse_count) && deck.verse_count >= 0
    ? deck.verse_count
    : allVerses.length;

  useEffect(() => {
    if (page >= pageCount) {
      setPage(pageCount - 1);
    }
  }, [page, pageCount]);

  return (
    <div style={{ height: '100%', overflow: 'auto', padding: '16px' }}>
      <div style={{ maxWidth: '760px', margin: '0 auto' }}>
        <md-elevated-card style={{ display: 'block', padding: '20px', marginBottom: '16px' }}>
          <h2 style={{ marginTop: 0 }}>{deckName}</h2>
          <dl>
            <dt>Visibility</dt>
            <dd>{deck.is_public ? 'Public' : 'Private by link'}</dd>
            <dt>Due date</dt>
            <dd>{deck.due_date || 'None'}</dd>
            <dt>Pace</dt>
            <dd>
              {deck.pace?.verses_per_day || 0} verses per day
              {deck.pace?.minutes_per_day ? ` · ${deck.pace.minutes_per_day} minutes` : ''}
            </dd>
            <dt>Verses</dt>
            <dd>{verseCount.toLocaleString()}</dd>
            <dt>Members</dt>
            <dd>
              {Number.isInteger(deck.participant_count)
                ? deck.participant_count.toLocaleString()
                : 'Not counted yet'}
            </dd>
          </dl>
        </md-elevated-card>
        <md-elevated-card style={{ display: 'block', padding: '20px' }}>
          <h2 style={{ marginTop: 0 }}>Verses</h2>
          <ol start={page * PAGE_SIZE + 1}>
            {verses.map(tuple => (
              <li key={tuple.join(':')} style={{ padding: '5px 0' }}>
                {formatVerseTuple(tuple)}
              </li>
            ))}
          </ol>
          {pageCount > 1 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <md-outlined-button
                {...(page === 0 ? { disabled: true } : {})}
                onClick={() => setPage(current => current - 1)}
              >
                Previous
              </md-outlined-button>
              <span>Page {page + 1} of {pageCount}</span>
              <md-outlined-button
                {...(page === pageCount - 1 ? { disabled: true } : {})}
                onClick={() => setPage(current => current + 1)}
              >
                Next
              </md-outlined-button>
            </div>
          )}
        </md-elevated-card>
      </div>
    </div>
  );
}
